/**
 * Labels table renderer with click-to-navigate.
 */

import { cpu, asm, hex, printableChar, escapeHtml } from "../state.js";
import { setPage } from "./mem.js";

export function renderLabels() {
    const body = document.getElementById("labels-body");
    const entries = Object.entries(asm.labels).sort((a, b) => a[1] - b[1]);
    if (entries.length === 0) {
        body.innerHTML = '<tr><td colspan="4" class="py-1" style="color:var(--t-dim);">no labels</td></tr>';
        return;
    }
    const multiPage = entries.some(([, addr]) => addr >= 256);
    body.innerHTML = entries
        .map(([name, addr]) => {
            const val = cpu.mem.get(addr);
            const raw = printableChar(val);
            const ch = raw ? `'${escapeHtml(raw)}'` : "";
            const addrStr = multiPage ? `${hex(addr >>> 8)}:${hex(addr & 0xff)}` : hex(addr);
            return `<tr style="cursor:pointer;" data-addr="${addr}"><td class="py-1">${name}</td><td class="py-1" style="color:var(--a-orange);">${addrStr}</td><td class="py-1">${hex(val)}</td><td class="py-1" style="color:var(--a-green);">${ch}</td></tr>`;
        })
        .join("");
}

// Click on label row navigates to its memory page
document.getElementById("labels-body").addEventListener("click", (e) => {
    const row = e.target.closest("[data-addr]");
    if (!row) return;
    const addr = parseInt(row.dataset.addr);
    setPage((addr >>> 8) & 0xff);
});
